import React, { createContext, useState } from "react";
import { getCookie } from "../common-service/CommonService";

export const StoreContext = createContext();

const StoreProvider = ({ children }) => {
  const isToken = getCookie("token") && getCookie.length > 0;
  const [isLoggedIn, setIsLoggedIn] = useState(isToken);
  const [user, setUser] = useState({});
  const [mobileMenu, setMobileMenu] = useState(false);
  const [subscriptionVersion, setSubscriptionVersion] = useState(0);
  const [paymentFailed, setPaymentFailed] = useState(false);

  const triggerSubscriptionRefresh = () =>
    setSubscriptionVersion((v) => v + 1);

  return (
    <StoreContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        user,
        setUser,
        mobileMenu,
        setMobileMenu,
        subscriptionVersion,
        triggerSubscriptionRefresh,
        paymentFailed,
        setPaymentFailed,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export default StoreProvider;
